<template>
  <div class="staff-list-description" v-cloak>
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane :label="$lange == 'en' ? 'Staff' : '员工详情'" name="description">
        <div class="top" v-if="staffData.sysUserInfo">
          <div class="left">
            <div
              class="image-box"
              :style="'background:url('+staffData.sysUserInfo.avatarurl+') no-repeat center / cover'"
            >
              <div class="upload-image">
                <cc-uploader
                  :config="uploaderConf2"
                  uploadType="dottedLine"
                  v-model="staffData.sysUserInfo.avatarurl"
                  v-if="isEdit"
                />
              </div>
            </div>
            <p>{{staffData.sysUserInfo.username}}</p>
          </div>

          <div class="right">
            <div class="form-box">
              <div class="input-box">
                <p>{{$lange == 'en' ? 'Department' : '部门'}}:</p>
                <p>{{staffData.sysUserInfo.deptName}}</p>
              </div>
              <div class="input-box">
                <p>{{$lange == 'en' ? 'Class' : '类别'}}:</p>
                <p>{{staffData.sysUserInfo.categoryName}}</p>
              </div>
              <div class="input-box">
                <p>{{$lange == 'en' ? 'Resident' : '驻地'}}:</p>
                <p>
                  <el-input size="mini" v-model="staffData.sysUserInfo.station" v-if="isEdit"></el-input>
                  <template v-else>{{staffData.sysUserInfo.station}}</template>
                </p>
              </div>
              <div class="input-box">
                <p>{{$lange == 'en' ? 'Skill' : '技能'}}:</p>
                <p>
                  <!-- <el-input size="mini" v-model="staffData.sysUserInfo.skill" v-if="isEdit"></el-input> -->
                  <template v-if="isEdit">
                    <el-select
                      v-model="staffData.sysUserInfo.skill"
                      :placeholder="$lange=='en' ? 'Engineer Skill' : '请选择技能'"
                      size="mini"
                      clearable
                    >
                      <el-option
                        v-for="item in skill"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </template>

                  <template v-else>{{staffData.sysUserInfo.skill}}</template>
                </p>
              </div>
              <div class="input-box">
                <p>{{$lange == 'en' ? 'Language ability' : '语言能力'}}:</p>
                <p>
                  <el-input size="mini" v-model="staffData.sysUserInfo.langSkills" v-if="isEdit"></el-input>
                  <template v-else>{{staffData.sysUserInfo.langSkills}}</template>
                </p>
              </div>
              <div class="input-box">
                <p>{{$lange == 'en' ? 'A business travel' : '目标出差'}}</p>
                <p>
                  <el-input
                    size="mini"
                    v-model="staffData.sysUserInfo.travelDays"
                    v-if="isEdit"
                    style="width: 70px"
                  ></el-input>
                  <template v-else>{{staffData.sysUserInfo.travelDays}}</template>
                  {{$lange == 'en' ? 'Day' : '天'}}
                </p>
              </div>
              <div class="input-box">
                <p
                  class="total"
                >{{$lange == 'en' ? 'Cumulative travel' : '累计出差'}} {{staffData.travelDaysTotal}} 天</p>
                <p
                  class="total"
                >{{$lange == 'en' ? 'Accumulated working hours' : '累计工时'}} {{staffData.workHourTotal}} 小时</p>
              </div>
            </div>
            <!--                        暂时隐藏, 后面可能会补-->
            <!--                        <div class="input-box">-->
            <!--                            <p>角色具备权限</p>-->
            <!--                            <p></p>-->
            <!--                        </div>-->
          </div>
          <div class="btn-group" v-if="!isIframe">
            <template v-if="isEdit">
              <el-button
                size="mini"
                type="default"
                @click="cancelSave"
              >{{$lange == 'en' ? 'Cancel' : '取消'}}</el-button>
              <el-button size="mini" type="primary" @click="save">{{$lange == 'en' ? 'Save' : '保存'}}</el-button>
            </template>
            <template v-else>
              <el-button
                size="mini"
                type="default"
                @click="isEdit = true"
              >{{$lange == 'en' ? 'Edit' : '编辑'}}</el-button>
            </template>
          </div>
        </div>
        <div class="bottom" v-if="!isIframe">
          <div class="title">{{$lange == 'en' ? 'Staff task' : '员工任务表'}}</div>
          <el-row>
            <el-col :span="14">
              <div class="table-box not-padding">
                <cc-table
                  :config="partsTableConfig"
                  :params="partsTableParams"
                  @pageNoChange="pageNoChange"
                  :load-data="partsTableParams.userId > 0"
                ></cc-table>
              </div>
            </el-col>
            <el-col :span="10" v-if="ganttData">
              <div class="gantt-box">
                <Gantt :utasks="ganttData"></Gantt>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="back-btn">
      <el-button type="primary" size="mini" @click="backBtn('/mgr')">返回列表</el-button>
    </div>
  </div>
</template>

<script>
import Gantt from "../../components/Gantt";
import moment from "moment";
export default {
  name: "StaffListDescription",
  components: {
    Gantt,
  },
  data() {
    return {
      skill: [
        {
          value: "安装",
          label: "安装",
        },
        {
          value: "售后",
          label: "售后",
        },
        {
          value: "质量",
          label: "质量",
        },
      ],
      pageNo: 1,
      isIframe: false, //从任务指派的iframe进来的时候，不显示部分信息
      hideBtn: false,
      activeName: "description",
      value: "",
      staffId: false,
      uploaderConf2: this.$uploadUtils.config,
      isEdit: false,
      staffData: {},
      partsTableParams: {
        userId: "",
      },
      ganttData: false,
      partsTableConfig: {
        api: "admin/fsb/employeeinfo/getEmployeeInfoList",
        showPager: true,
        pageLayout: "total, prev, pager, next, jumper",
        pageSize: 10,
        columns: [
          {
            prop: "type",
            lable: this.$lange == "en" ? "Task type" : "任务类型",
            type: "tag",
            options: [
              {
                tagType: "Blue",
                text: this.$lange == "en" ? "Installation project" : "安装项目",
              },
              {
                tagType: "success",
                text:
                  this.$lange == "en"
                    ? "Onsite Service Processing"
                    : "外派服务单",
              },
              { tagType: "info", text: this.$lange == "en" ? "leave" : "请假" },
            ],
          },
          {
            prop: "jobId",
            lable: "JOBID",
            type: "input",
          },
          {
            prop: "customerName",
            lable: this.$lange == "en" ? "Customer" : "客户",
            type: "input",
          },
          {
            prop: "status",
            lable: this.$lange == "en" ? "Status" : "状态",
            minWidth: 120,
            type: "tag",
            options: [
              {
                tagType: "info",
                text: this.$lange == "en" ? "Not yet begun" : "未开始",
              },
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Have in hand" : "进行中",
              },
              {
                tagType: "success",
                text: this.$lange == "en" ? "Completed" : "已完成",
              },
              {
                tagType: "danger",
                text: this.$lange == "en" ? "Delay" : "延期",
              },
            ],
          },
          {
            prop: "startTime",
            lable: this.$lange == "en" ? "Start time" : "开始时间",
            type: "date",
          },
          {
            prop: "endTime",
            lable: this.$lange == "en" ? "End time" : "结束时间",
            type: "input",
            editAble: true,
            required: true,
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Operation" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "View Detail" : "查看",
            click: (row) => {
              if (row.type === 0) {
                this.$router.push({
                  path: "/admin/project/description",
                  query: {
                    fasId: row.fasId,
                  },
                });
              }
              if (row.type === 1) {
                if (row.expatriateOrderId.length < 1) {
                  return this.$message({
                    type: "warning",
                    message: "该外派单是错误数据",
                  });
                }
                this.$router.push({
                  path: "/admin/order/expatriate/des",
                  query: {
                    id: row.expatriateOrderId,
                  },
                });
              }
            },
          },
        ],
      },
      empList: [],
    };
  },
  methods: {
    backBtn() {
      this.$router.go(-1);

      // window.open(window.location.origin + "/mgr");
    },
    pageNoChange(num) {
      console.log(num, "pageNo");
      this.pageNo = num;
      this.getEmpList();
    },
    getAdmin() {
      this.ccRequest.do("validate", {}, "GET").then((res) => {
        this.staffId = res.id;
        this.partsTableParams.userId = this.staffId;
        this.getData();
      });
    },
    getEmployee() {
      let data = {
        userId: this.staffId,
      };

      this.ccRequest
        .do("admin/fsb/employeeinfo/getEmployeeInfo", data, "GET")
        .then((res) => {
          this.staffData = res;
          this.isEdit = false;
        });
    },
    getEmpList() {
      let data = {
        userId: this.staffId,
        pageNo: this.pageNo,
        pageSize: 10,
      };
      this.ccRequest
        .do("admin/fsb/employeeinfo/getEmployeeInfoList", data, "GET")
        .then((res) => {
          this.empList = res.rows;
          this.initGantt();
        });
    },
    initGantt() {
      this.ganttData = this.empList;
    },
    getData() {
      this.getEmployee();
      this.getEmpList();
    },
    cancelSave() {
      // 把开关放到请求接口里是为了解决 编辑后点击取消，还是会保存
      this.getEmployee();
    },
    save() {
      let staffData = this.staffData.sysUserInfo;
      let data = {
        id: staffData.id,
        avatarurl: staffData.avatarurl,
        station: staffData.station,
        skill: staffData.skill,
        langSkills: staffData.langSkills,
        travelDays: staffData.travelDays * 1,
      };
      this.ccRequest
        .do("admin/fsb/employeeinfo/save", data, "POSTJSON")
        .then((res) => {
          this.isEdit = false;
          this.$message({
            type: "success",
            message: "保存成功",
          });
        });
    },
  },
  mounted() {
    if (this.$route.query.id) {
      this.staffId = this.$route.query.id;
      this.partsTableParams.userId = this.staffId;
      this.getData();
      console.log("getData");
    } else {
      console.log("getAdmin");
      this.getAdmin();
    }

    if (this.$route.query.hideBtn) {
      this.hideBtn = true;
    }
  },
};
</script>

<style scoped lang="scss">
.staff-list-description {
  .top {
    position: relative;
    padding: 20px;
    background: #ffffff;
    display: flex;
    .left {
      .image-box {
        position: relative;
        width: 200px;
        height: 200px;
        margin-bottom: 20px;
      }
      text-align: center;
    }
    .right {
      margin-left: 30px;
      .form-box {
        display: flex;
        flex-wrap: wrap;
        max-width: 590px;
        .input-box {
          display: flex;
          margin-bottom: 30px;
          align-items: center;
          p:last-child:not(.total) {
            flex: 1;
            width: 140px;
            margin-right: 20px;
            margin-left: 5px;
          }
          .total {
            margin-left: 5px;
            padding: 2px 4px;
            color: #ffffff;
            background: #1ab394;
          }
        }
      }
    }
  }
  .bottom {
    margin-top: 20px;
    padding: 20px;
    background: #ffffff;
    border-top: 1px solid #e4e4e4;

    .title {
      margin-bottom: 20px;
      font-size: 20px;
    }
    .table-box {
      overflow-x: scroll;
    }
    .gantt-box {
      background: #ffffff;
      box-sizing: border-box;
    }
  }
  .btn-group {
    position: absolute;
    right: 20px;
    top: 20px;
  }
}
</style>
